/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** START CROSS-SELLING */

class BBCrossSelling extends HTMLElement {
  connectedCallback() {
    this.fetchRecommendations().then(() => {
      this.renderValues()
    })

    document.addEventListener('cart:opened', () => {
      this.fetchRecommendations().then(() => {
        const deleteImage = this.querySelectorAll('rec-img img')[0]
        deleteImage.parentNode.removeChild(deleteImage)
        this.renderValues()
      })
    })
  }

  async fetchRecommendations() {
    // fetch /recommendations/products.json?product_id=
    const recommendations = await fetch('/recommendations/products.json?product_id=' + this.getAttribute('data-product-id') + '&intent=complementary').then(response => response.json())
    this.recommendation = recommendations.products[0]

    if (this.recommendation == undefined) {
      return
    }
    this.variantId = this.recommendation.variants[0].id
    this.selectedVariant = this.recommendation.variants.find(variant => variant.id == this.variantId)
    this.updatedPrice = this.selectedVariant.price
  }

  renderValues() {
    if (this.recommendation == undefined) {
      this.style.display = 'none'
      return
    }
    Object.keys(this.recommendation).forEach(key => {
      // key to kebab-case
      const kebapKey = key.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase()
      const element = this.querySelector(`rec-${key}`)
      if (element) {
        element.textContent = this.recommendation[key]
      }
    })

    // render variant select
    if (this.recommendation.variants.length > 1) {
      if (this.querySelector('rec-select').innerHTML != '') {
        return
      } else {
        this.querySelectorAll('rec-select').forEach(select => {
          select.innerHTML = `
            <select>
              ${this.recommendation.variants.map(variant => `<option value="${variant.id}" ${variant.available ? `` : `disabled`} >${variant.title}</option>`).join('')}
            </select>
          `
          select.querySelectorAll('select').forEach(select => {
            select.addEventListener('change', (event) => {
              event.stopPropagation() 
              this.variantId = parseInt(event.target.value)
              this.selectedVariant = this.recommendation.variants.find(variant => variant.id == this.variantId)
              this.recommendation.price = this.selectedVariant.price

              this.querySelectorAll('option').forEach(option => {
                if (option.value == this.variantId) {
                  option.selected = true;
                }
              })
              if (this.recommendation.price) {
                this.querySelectorAll('rec-var-price').forEach(price => {
                  price.textContent =  new Intl.NumberFormat([window?.Shopify?.locale, window?.Shopify?.country].filter(Boolean).join('-') || undefined, { style: 'currency', currency: window?.Shopify?.currency?.active ?? 'EUR' }).format(this.selectedVariant.price / 100)
                })
              }
            })
          })
        })
        
      }
    }

    // render price
    if (this.recommendation.price) {
      this.querySelectorAll('rec-var-price').forEach(price => {
        price.textContent =  new Intl.NumberFormat([window?.Shopify?.locale, window?.Shopify?.country].filter(Boolean).join('-') || undefined, { style: 'currency', currency: window?.Shopify?.currency?.active ?? 'EUR' }).format(this.selectedVariant.price / 100)
      })
    }

    // render image
    if (this.recommendation.featured_image) {
      this.querySelectorAll('rec-img').forEach(img => {
        const imgComp = document.createElement('img')
        imgComp.src = this.recommendation.featured_image
        imgComp.setAttribute('class', img.getAttribute('class'))
        img.removeAttribute('class')
        img.appendChild(imgComp)
      })
    }
  }

  async addToCart(elm) {
    elm.setAttribute("aria-busy", "true");
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': [{
            'id': this.variantId,
            'quantity': 1
          }]
        })
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      elm.setAttribute("aria-busy", "false");

      this.dispatchEvent(new CustomEvent("product:added", {
        bubbles: true,
        detail: {
          variant: null,
          quantity: 1
        }
      }));

    } catch (error) {
      console.error('Error adding to cart:', error)
    }
  }
}
if (!customElements.get('bb-cross-selling')) {
  customElements.define('bb-cross-selling', BBCrossSelling);
}

class RecAtc extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.addToCart.bind(this))
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.addToCart.bind(this))
  }
  
  addToCart() {
    this.closest('bb-cross-selling').addToCart(this)
  }
}
if (!window.customElements.get('rec-atc')) {
window.customElements.define('rec-atc', RecAtc)
}

class ShopWishlist {
  async getList () {
    const localStorageValue = localStorage.getItem('painless::wishlist')
    if (localStorageValue == null) return []
    try {
      JSON.parse(localStorageValue)
    } catch (e) {
      return []
    }
    return JSON.parse(localStorageValue)
  }

  setList (handles) {
    localStorage.setItem('painless::wishlist', JSON.stringify(handles ?? []))
    document.dispatchEvent(new CustomEvent('wishlist:changed'))
  }

  async hasEntry (handle) {
    const list = await this.getList()
    return list.some(h => h === handle)
  }

  async removeEntry (handle) {
    const list = await this.getList()
    this.setList(list.filter(h => h !== handle))
  }

  async addEntry (handle) {
    const list = await this.getList()
    if (list.some(h => h === handle)) return
    list.push(handle)
    this.setList(list)
  }

  clearList () {
    this.setList()
  }
}


  class ProductItem extends HTMLElement {
    constructor() {
      super();
      this.card = this.querySelector('.card-wrapper')
    }

    // Wishlist
    
    async connectedCallback () {
      const wishlist = new ShopWishlist()
      
      const handlePopup = (isOpen) => {
        if (popup == null) return
        if (isOpen) { 
          popup.classList.add('add')
          popup.classList.remove('remove')
          popup.querySelector('.wishlist-popup__text--open').classList.remove('hidden'); 
          popup.querySelector('.wishlist-popup__text--close').classList.add('hidden');
        } else {
          popup.classList.add('remove')
          popup.classList.remove('add')
          popup.querySelector('.wishlist-popup__text--close').classList.remove('hidden');
          popup.querySelector('.wishlist-popup__text--open').classList.add('hidden');
        }
        setTimeout(function() {
          popup.classList.remove('hidden');
          setTimeout(function() {
              popup.classList.add('show');
          }, 10);
        }, 300);
    
        setTimeout(function() {
          popup.classList.remove('show');
          setTimeout(function() {
              popup.classList.add('hidden');
          }, 1000);
        }, 3000);
      }
      if (!this.card) return

      const popup = this.card.querySelector('[data-popup]')
      if (popup) {
        const fixedContainer = document.createElement('div')
        fixedContainer.appendChild(popup)
        document.body.appendChild(fixedContainer)
        popup.querySelector('.wishlist-popup__text--undo').addEventListener('click', function () {
          const handle = this.dataset.handle
          if (handle == null) return
          wishlist.addEntry(handle)
          addToWishlistButton.classList.add('hidden')
          removeFromWishlistButton.classList.remove('hidden')
          handlePopup(true)
        })
      }

      const addToWishlistButton = this.card.querySelector('.card__wishlist-add');
      const removeFromWishlistButton = this.card.querySelector('.card__wishlist-remove');
      
      if (addToWishlistButton) {
        addToWishlistButton.addEventListener('click', async function () {
          const handle = this.dataset.handle
          if (handle == null) return
          wishlist.addEntry(handle)
          addToWishlistButton.classList.add('hidden')
          removeFromWishlistButton.classList.remove('hidden')
          handlePopup(true)
        })
      }
      if (removeFromWishlistButton) {
        removeFromWishlistButton.addEventListener('click', async function () {
          const wishlist = new ShopWishlist()
          const handle = this.dataset.handle
          if (handle == null) return
          wishlist.removeEntry(handle)
          addToWishlistButton.classList.remove('hidden')
          removeFromWishlistButton.classList.add('hidden')
          handlePopup(false)
        })
      }

      if (addToWishlistButton && removeFromWishlistButton) {
        const handle = addToWishlistButton.dataset.handle
        if (handle == null) return
        const hasEntry = await wishlist.hasEntry(handle)
        if (hasEntry) {
          addToWishlistButton.classList.add('hidden')
          removeFromWishlistButton.classList.remove('hidden')
        } else {
          addToWishlistButton.classList.remove('hidden')
          removeFromWishlistButton.classList.add('hidden')
        }
      }
    }
  }
  if (!customElements.get('product-item')) {
    customElements.define('product-item', ProductItem)
  }

class ShopWishlistGrid extends HTMLElement {  
  wishlist = new ShopWishlist()
  grid = document.querySelector('[data-grid]')
  // removeAll = document.querySelector('[data-remove-all]')

  async connectedCallback () {
    if (window.location.hash.includes('#wishlist-')) {
      await this.fetchWishlistFromUrl()
    } else {
      await this.fetchWishlist()
    }
/*
    this.removeAll?.addEventListener('click', async () => {
      this.wishlist.clearList()
      await this.fetchWishlist()
    })
    */

   document.querySelector('[data-wishlist-share]')?.addEventListener('click', async () => {
    const list = await this.wishlist.getList()
    const encoded = encodeURIComponent(list.join(';'))
    if (window.location.hash.includes('#wishlist-')) {
      try {
        await navigator.share({
          text: 'Wunschliste',
          url: `${window.location.href}`,
          title: 'Wunschliste'
        })
      } catch (e) {
        await navigator.clipboard.writeText(`${window.location.href}`)
      }
    } else {
      try {
        await navigator.share({
          text: 'Wunschliste',
          url: `${window.location.href}#wishlist-${encoded}`,
          title: 'Wunschliste'
        })
      } catch (e) {
        await navigator.clipboard.writeText(`${window.location.href}#wishlist-${encoded}`)
      }
    }
   })
  }
  async addAllToCart (formData) {
    /*const cart = document.querySelector('cart-drawer')
    // cart.addItem(formData.items)
    let items = formData.items.map(item => ({
      id: item.id,
      quantity: parseInt(item.quantity)
    }))
    for (const item of items) {
      await cart.addItem(item)
    }
    cart.fetch()
    */
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    const url = new URL(window.location.href)
    url.searchParams.set('cart', 'open')
    window.location.href = url
    //cart.open()
  }

  async fetchWishlist () {
    const list = await this.wishlist.getList()
    const encoded = encodeURIComponent(list.join(';'))
    const url = `/search?view=wishlist&q=${encoded}`
    const response = await fetch(url)
    const html = await response.text()
    this.grid.innerHTML = html
    this.querySelectorAll('[data-remove-from-wishlist]').forEach(elm => {
      elm.addEventListener('click', async (evt) => {
        const handle = (elm).dataset.removeFromWishlist ?? ''
        await this.wishlist.removeEntry(handle)
        await this.fetchWishlist()
      })
    })
    this.addListeners()
  }

  async fetchWishlistFromUrl () {
    const hash = window.location.hash.replace('#wishlist-', '')
    const url = `/search?view=wishlist&q=${hash}`
    const decoded = decodeURIComponent(hash)
    const list = decoded.split(';')
    const response = await fetch(url)
    const html = await response.text()
    this.grid.innerHTML = html
    this.addListeners()
  }

  addListeners () {
    document.querySelector('[data-add-all]')?.addEventListener('click', async () => {
      console.log('ADD ALL')
      const btns = document.querySelectorAll('.button--available')
      let formData = {
        'items': []
      }
      btns.forEach(async (btn) => {
        const handle = btn.dataset.wishlistAtc
        const id = btn.dataset.id
        formData.items.push({
          'id': id,
          'quantity': 1
         })
      })
      await this.addAllToCart(formData)
    })
  }
}
if (!customElements.get('shop-wishlist-grid')) {
  customElements.define('shop-wishlist-grid', ShopWishlistGrid)
}


class WishlistButtons extends HTMLElement {  
  wishlist = new ShopWishlist()
  pbWishlist = document.querySelector('.button-wishlist-add')
  pbWishlistAdd = document.querySelector('[data-wishlist-add]')
  pbWishlistAdded = document.querySelector('[data-wishlist-added]')
  
  async connectedCallback() {
    await this.checkWishlist()
    this.pbWishlist.addEventListener('click', async () => {
      await this.handlePbButton()
    })
  }
  
  async handlePbButton () {
    const handle = this.pbWishlist.dataset.handle
    if (handle == null) return
    const hasEntry = await this.wishlist.hasEntry(handle)
    if (hasEntry) {
      this.pbWishlist.classList.remove('button-wishlist-added')
      this.pbWishlist.classList.add('button-wishlist-add')
      this.pbWishlistAdd.classList.remove('hidden')
      this.pbWishlistAdded.classList.add('hidden')
      this.wishlist.removeEntry(handle)
    } else {
      this.pbWishlist.classList.remove('button-wishlist-add')
      this.pbWishlist.classList.add('button-wishlist-added')
      this.pbWishlistAdd.classList.add('hidden')
      this.pbWishlistAdded.classList.remove('hidden')
      this.wishlist.addEntry(handle)
    }
  }
  
  async checkWishlist () {
    const handle = this.pbWishlist.dataset.handle
    if (handle == null) return
    const hasEntry = await this.wishlist.hasEntry(handle)
    if (hasEntry) {
      this.pbWishlist.classList.remove('button-wishlist-add')
      this.pbWishlist.classList.add('button-wishlist-added')
      this.pbWishlistAdd.classList.add('hidden')
      this.pbWishlistAdded.classList.remove('hidden')
    } else {
      this.pbWishlist.classList.remove('button-wishlist-added')
      this.pbWishlist.classList.add('button-wishlist-add')
      this.pbWishlistAdd.classList.remove('hidden')
      this.pbWishlistAdded.classList.add('hidden')
    }
  }
}
if (!customElements.get('wishlist-buttons')) {
  customElements.define('wishlist-buttons', WishlistButtons)
}

/** START SMOOTH COMBINED LISTING VARIANT CHANGE */

/**
 * Variant changes via Shopify combined listings navigate to another product page, which resets
 * the scroll position to the top and causes a visible flicker. To make the transition 100% smooth,
 * we intercept those navigations, fetch the new product page in the background and replace the
 * product section in place, re-using the theme's own section lifecycle events
 * (shopify:section:unload / shopify:section:load) so all theme features (gallery, zoom, sticky
 * form, custom elements, ...) re-initialize exactly like they do in the Shopify theme editor.
 * The URL is updated via the History API. If anything goes wrong, we gracefully fall back to a
 * regular navigation that restores the scroll position on the next page load.
 */
(function () {
  var STORAGE_KEY = 'bb::variant-change-scroll-position'
  var MAX_AGE = 30000 // Only restore the position if the navigation happened within the last 30 seconds
  var hasSwapped = false
  var abortController = null
  var swappedPath = null
  var infoCardScroller = null

  var INFO_CARD_SELECTOR = '.product-block-list__item--info .card'

  /**
   * The theme's ProductSection creates an OverflowScroller for the sticky info card
   * (.card--sticky) which drives the card's inline `top` style based on scroll deltas. That
   * scroller assumes it is constructed on a fresh page load (scroll state and the card's `top`
   * both at their initial values). When we re-initialize the section mid-scroll after a swap,
   * its internal state resets to 0 while the page stays scrolled, so the card jumps to a wrong
   * position. We therefore disable the theme scroller for swapped-in sections (via the
   * `infoOverflowScroll` section setting the theme reads from the DOM) and run an equivalent
   * scroller here, seeded with the card's previous inline `top` so the position is preserved.
   */
  function disableThemeInfoOverflowScroll(sectionWrapper) {
    var container = sectionWrapper.querySelector('[data-section-settings]')
    if (!container) return false
    try {
      var settings = JSON.parse(container.getAttribute('data-section-settings'))
      if (!settings['infoOverflowScroll']) return false
      settings['infoOverflowScroll'] = false
      container.setAttribute('data-section-settings', JSON.stringify(settings))
      return true
    } catch (e) {
      return false
    }
  }

  // Mirrors the theme's OverflowScroller (theme.js), but starts from the given `top` instead of 0
  function createInfoCardScroller(element, previousInlineTop) {
    var lastKnownY = window.scrollY
    var initialTopOffset = parseInt(window.getComputedStyle(element).top)
    if (isNaN(initialTopOffset)) initialTopOffset = 0
    var currentTop = parseFloat(previousInlineTop)
    if (isNaN(currentTop)) currentTop = 0
    if (previousInlineTop !== '') {
      element.style.top = previousInlineTop
    }

    var scheduledFrame = null

    function onScroll() {
      var bounds = element.getBoundingClientRect()
      // 30px matches the theme's offsetBottom/offsetTop spacing around the sticky card
      // Highest `top` the card may get so it never sits above its natural document position
      var maxTop = bounds.top + window.scrollY - element.offsetTop + initialTopOffset
      var minTop = element.clientHeight - window.innerHeight + 30
      currentTop += lastKnownY - window.scrollY
      currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset)
      lastKnownY = window.scrollY
      if (scheduledFrame === null) {
        // Batch style writes per frame, like the theme's fastdom-based OverflowScroller
        scheduledFrame = requestAnimationFrame(function () {
          scheduledFrame = null
          element.style.top = currentTop + 'px'
        })
      }
    }

    window.addEventListener('scroll', onScroll)
    return {
      destroy: function () {
        window.removeEventListener('scroll', onScroll)
        if (scheduledFrame !== null) {
          cancelAnimationFrame(scheduledFrame)
        }
      }
    }
  }

  function saveScrollPosition() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        scrollY: window.scrollY,
        timestamp: Date.now()
      }))
    } catch (e) {
      // sessionStorage might be unavailable (e.g. private mode); fail silently
    }
  }

  // Only same-origin http(s) product URLs may be handled; everything else keeps the default browser behavior
  function resolveSameOriginUrl(url) {
    var resolved
    try {
      resolved = new URL(url, window.location.href)
    } catch (e) {
      return null
    }
    if (resolved.origin !== window.location.origin || (resolved.protocol !== 'http:' && resolved.protocol !== 'https:')) {
      return null
    }
    return resolved
  }

  function fallbackNavigate(url) {
    saveScrollPosition()
    window.location.href = url.href
  }

  async function swapProductSection(url, sectionWrapper) {
    if (abortController) {
      abortController.abort()
    }
    abortController = new AbortController()

    document.dispatchEvent(new CustomEvent('theme:loading:start'))

    try {
      // Use the Section Rendering API to fetch only the product section instead of the whole page.
      // The wrapper id is "shopify-section-<sectionId>", so strip the prefix to get the section id.
      var renderSectionId = sectionWrapper.id.replace(/^shopify-section-/, '')
      var fetchUrl = new URL(url.href)
      fetchUrl.searchParams.set('section_id', renderSectionId)

      var response = await fetch(fetchUrl.href, { signal: abortController.signal })
      if (!response.ok) {
        throw new Error('Failed to fetch ' + fetchUrl.href)
      }
      // The response contains only the section markup (including its "shopify-section-..." wrapper)
      var newDocument = new DOMParser().parseFromString(await response.text(), 'text/html')
      var newSectionWrapper = newDocument.getElementById(sectionWrapper.id)
      if (!newSectionWrapper) {
        throw new Error('Section ' + sectionWrapper.id + ' not found in fetched section')
      }

      var oldSectionId = sectionWrapper.querySelector('[data-section-id]')?.getAttribute('data-section-id')
      var newSectionId = newSectionWrapper.querySelector('[data-section-id]')?.getAttribute('data-section-id')

      // Remember the sticky info card's current inline `top` (set by the theme's OverflowScroller
      // or by our own scroller from a previous swap) so the new card keeps the exact same position;
      // an empty string means no inline `top` was set (the user hasn't scrolled yet)
      var previousInlineTop = sectionWrapper.querySelector(INFO_CARD_SELECTOR)?.style.top ?? ''
      var themeScrollerDisabled = disableThemeInfoOverflowScroll(newSectionWrapper)

      // Tear down the JS instances bound to the old section content (same as the theme editor does)
      if (oldSectionId) {
        document.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: oldSectionId } }))
      }
      if (infoCardScroller) {
        infoCardScroller.destroy()
        infoCardScroller = null
      }

      sectionWrapper.replaceWith(newSectionWrapper)

      if (newDocument.title) {
        document.title = newDocument.title
      }

      hasSwapped = true
      history.pushState({}, '', url.href)

      // Re-initialize the theme's section JS (gallery, zoom, videos, ...) for the new content
      newSectionWrapper.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: newSectionId } }))

      // Take over the sticky info card positioning from the (disabled) theme scroller
      if (themeScrollerDisabled) {
        var infoCardElement = newSectionWrapper.querySelector(INFO_CARD_SELECTOR)
        if (infoCardElement) {
          infoCardScroller = createInfoCardScroller(infoCardElement, previousInlineTop)
        }
      }

      document.dispatchEvent(new CustomEvent('theme:loading:end'))
    } catch (error) {
      if (error?.name === 'AbortError') {
        // A newer request superseded this one and will end the loading indicator itself
        return
      }
      document.dispatchEvent(new CustomEvent('theme:loading:end'))
      fallbackNavigate(url)
    }
  }

  // Once we swapped content in place, history traversal (back/forward) must reload the page so
  // the correct product is always displayed. Hash-only traversals are left untouched.
  window.addEventListener('popstate', function () {
    if (hasSwapped && window.location.pathname + window.location.search !== swappedPath) {
      window.location.reload()
    }
  })

  // Combined listing options rendered as links (color swatches, variant swatches)
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    var link = event.target instanceof Element ? event.target.closest('variant-picker a[href]') : null
    if (!link) return

    var url = resolveSameOriginUrl(link.getAttribute('href'))
    if (!url) return

    var sectionWrapper = link.closest('.shopify-section')
    if (!sectionWrapper || !sectionWrapper.id) {
      // No section wrapper (e.g. quick view modal): let the regular navigation happen but keep the scroll position
      saveScrollPosition()
      return
    }

    event.preventDefault()
    swappedPath = url.pathname + url.search
    swapProductSection(url, sectionWrapper)
  }, true)

  // Combined listing options rendered as dropdowns navigate via the option's data-update-url (handled in theme.js)
  document.addEventListener('change', function (event) {
    var target = event.target
    if (!(target instanceof HTMLSelectElement) || !target.closest('variant-picker')) return
    if (!(target.selectedOptions.length > 0 && target.selectedOptions[0].hasAttribute('data-update-url'))) return

    var url = resolveSameOriginUrl(target.selectedOptions[0].getAttribute('data-update-url'))
    var sectionWrapper = target.closest('.shopify-section')
    if (!url || !sectionWrapper || !sectionWrapper.id) {
      // theme.js will perform the regular navigation; keep the scroll position
      saveScrollPosition()
      return
    }

    // Prevent theme.js from performing the full page navigation
    event.stopPropagation()
    swappedPath = url.pathname + url.search
    swapProductSection(url, sectionWrapper)
  }, true)

  // Fallback path: restore the scroll position after a regular navigation
  function restoreScrollPosition() {
    var storedValue
    try {
      storedValue = sessionStorage.getItem(STORAGE_KEY)
      sessionStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      return
    }
    if (storedValue == null) return
    var position
    try {
      position = JSON.parse(storedValue)
    } catch (e) {
      return
    }
    if (position == null || typeof position.scrollY !== 'number' || typeof position.timestamp !== 'number') return
    if (Date.now() - position.timestamp > MAX_AGE) return
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
    window.scrollTo(0, position.scrollY)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScrollPosition)
  } else {
    restoreScrollPosition()
  }
})()

/** END SMOOTH COMBINED LISTING VARIANT CHANGE */

document.addEventListener('DOMContentLoaded', function() {
  var showProductCheckbox = document.querySelector('[name="filter.p.m.custom.show"]')
  if (showProductCheckbox) {
    if (showProductCheckbox.checked) {
    } else {
      showProductCheckbox.click()
    }
  }
})

if (!window.bbSwatchQuickBuySync) {
  window.bbSwatchQuickBuySync = true

  var bbSiblingProductCache = {}
  var bbPrefetchedImages = {}

  var bbFetchSiblingProduct = function (productJsUrl) {
    bbSiblingProductCache[productJsUrl] = bbSiblingProductCache[productJsUrl] || fetch(productJsUrl).then(function (response) {
      if (!response.ok) throw new Error(response.status)
      return response.json()
    })

    return bbSiblingProductCache[productJsUrl]
  }

  var bbPrefetchImage = function (imageUrl) {
    if (!imageUrl || bbPrefetchedImages[imageUrl]) return
    bbPrefetchedImages[imageUrl] = true
    new Image().src = imageUrl
  }

  // Resolves the swatch's media (fetching the combined-listing sibling if needed) and stashes it on the input
  var bbResolveSwatchMedia = function (input) {
    if (input.getAttribute('data-image-url') && input.getAttribute('data-media-id')) {
      return Promise.resolve(input)
    }

    var siblingUrl = input.getAttribute('data-variant-url')

    if (!siblingUrl || siblingUrl.indexOf('/products/') === -1) {
      return Promise.reject(new Error('no sibling url'))
    }

    var productJsUrl = siblingUrl.split('?')[0] + '.js'

    return bbFetchSiblingProduct(productJsUrl).then(function (siblingProduct) {
      var media = siblingProduct.media && siblingProduct.media[0]
      if (!media || !media.preview_image) {
        throw new Error('no media')
      }

      var fetchedImageUrl = media.preview_image.src + (media.preview_image.src.indexOf('?') === -1 ? '?' : '&') + 'width=800'
      var fetchedAspectRatio = media.preview_image.aspect_ratio || (media.preview_image.width / media.preview_image.height)

      input.setAttribute('data-media-id', media.id)
      input.setAttribute('data-image-url', fetchedImageUrl)
      input.setAttribute('data-image-aspect-ratio', fetchedAspectRatio)

      return input
    }).catch(function (error) {
      delete bbSiblingProductCache[productJsUrl]
      throw error
    })
  }

  var bbSwapCardImage = function (productItem, mediaId, imageUrl, aspectRatio) {
    var primaryImage = productItem.querySelector('.product-item__primary-image')
    if (!primaryImage || !imageUrl || !mediaId || mediaId === primaryImage.getAttribute('data-media-id')) return

    var newImage = document.createElement('img')
    newImage.className = 'product-item__primary-image'
    newImage.setAttribute('data-media-id', mediaId)
    newImage.setAttribute('src', imageUrl)
    newImage.setAttribute('loading', 'lazy')
    if (primaryImage.hasAttribute('alt')) newImage.setAttribute('alt', primaryImage.getAttribute('alt'))

    var ratio = parseFloat(aspectRatio)
    if (ratio) primaryImage.parentNode.style.paddingBottom = (100 / ratio) + '%'

    primaryImage.parentNode.replaceChild(newImage, primaryImage)
  }

  document.addEventListener('change', function (event) {
    var input = event.target
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('color-swatch__radio')) return

    var productItem = input.closest('.product-item')
    if (!productItem) return

    var variantId = input.getAttribute('data-variant-id')

    productItem.querySelectorAll('[data-action="add-to-cart"]').forEach(function (button) {
      button.toggleAttribute('disabled', !variantId)
    })

    // Swap the card image to the selected variant's featured image
    var imageUrl = input.getAttribute('data-image-url')
    var mediaId = input.getAttribute('data-media-id')

    if (imageUrl && mediaId) {
      bbSwapCardImage(productItem, mediaId, imageUrl, input.getAttribute('data-image-aspect-ratio'))
    } else {
      // Combined listing sibling without pre-resolved media: fetch the sibling product's featured image
      bbResolveSwatchMedia(input).then(function () {
        if (input.checked) {
          bbSwapCardImage(productItem, input.getAttribute('data-media-id'), input.getAttribute('data-image-url'), input.getAttribute('data-image-aspect-ratio'))
        }
      }).catch(function () {})
    }

    if (!variantId) return

    productItem.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (idInput) {
      idInput.value = variantId
    })

    productItem.querySelectorAll('[data-wishlist-atc]').forEach(function (button) {
      button.setAttribute('data-id', variantId)
    })
  })

  // Prefetch sibling product data + image on swatch hover/touch so the swap is instant on click
  var bbPrefetchSwatch = function (event) {
    var swatch = event.target.closest && event.target.closest('.color-swatch')
    if (!swatch) return

    var input = swatch.querySelector('.color-swatch__radio')
    if (!input || input.checked) return

    bbResolveSwatchMedia(input).then(function () {
      bbPrefetchImage(input.getAttribute('data-image-url'))
    }).catch(function () {})
  }

  document.addEventListener('pointerover', bbPrefetchSwatch)
  document.addEventListener('touchstart', bbPrefetchSwatch, { passive: true })
}

if (!window.bbWishlistHeaderCount) {
  window.bbWishlistHeaderCount = true

  var updateWishlistHeaderCount = function () {
    var list = []
    try {
      list = JSON.parse(localStorage.getItem('painless::wishlist')) || []
    } catch (e) {
      list = []
    }

    document.querySelectorAll('.header__wishlist-count').forEach(function (countElement) {
      countElement.textContent = list.length
      countElement.toggleAttribute('hidden', list.length === 0)
    })
  }

  document.addEventListener('wishlist:changed', updateWishlistHeaderCount)

  window.addEventListener('storage', function (event) {
    if (event.key === 'painless::wishlist') {
      updateWishlistHeaderCount()
    }
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistHeaderCount)
  } else {
    updateWishlistHeaderCount()
  }
}
